/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { MobileOnly, MediumUp } from 'src/ui/block';
import { MainOfferlistFiltersDropdown } from './components/main-offerlist-filters-dropdown';
import { MainOfferlistFiltersMobile } from './components/main-offerlist-filters-mobile';
import { IOfferListFilters } from './types';

export const OfferListFilters = ({
  applicableFilters,
  activeOfferlistFilters,
  onSort,
  currentSorting,
  sortOptions,
}: IOfferListFilters) => {
  return (
    <>
      <MobileOnly>
        <MainOfferlistFiltersMobile
          applicableFilters={applicableFilters}
          activeOfferlistFilters={activeOfferlistFilters}
          onSort={onSort}
          currentSorting={currentSorting}
          sortOptions={sortOptions}
        />
      </MobileOnly>
      <MediumUp>
        <MainOfferlistFiltersDropdown
          applicableFilters={applicableFilters}
          activeOfferlistFilters={activeOfferlistFilters}
        />
      </MediumUp>
    </>
  );
};
